import { Image } from "antd";
import React from "react";
import { rooms } from "./Rooms";
import { useTranslation } from "react-i18next";
import { homeDeVuong, ks1, ks2, ks3, ks4, phongNghi, sanh } from "../assets/images";

const GalleryImagge = () => {
  const { t } = useTranslation();
  const images = rooms.map((room) => room.image).flat();
  const ks = [
    sanh,homeDeVuong,ks1,ks2,ks3,ks4, ...images
  ]
  return (
    <section className="py-[10px] ">
      <p className="uppercase text-[18px] font-cormorant">
        {t("photo_gallery")}
      </p>
      <p className="bg-gray-200 border-[1px] mt-[10px] mb-[40px]"></p>
      {/* Heading and Description */}
      <div className="text-center mb-8">
        <h3 className="text-[28px] font-medium text-gray-800 font-cormorant">
          {t("GALLERY_COLLECTION")}
        </h3>
        <h2 className="text-3xl font-medium text-[#fbbe17] mt-2 font-cormorant">
          {t("HOTEL_NAME")}
        </h2>
        <p className="text-gray-600 font-[400] mt-4 px-[20px] text-[16px] lg:mx-[100px] ssx:mx-[10px]">
          {t("GALLERY_DESCRIPTION")}
        </p>
      </div>

      {/* Image Gallery */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {ks.map((src, index) => (
          <div key={index} className="w-full h-[450px] overflow-hidden rounded">
            <Image
              src={src}
              alt={`Gallery Image ${index + 1}`}
              className="object-fill hover:scale-110 duration-[0.5s]"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default GalleryImagge;
